<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Incident Witness Form</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <form #form="ngForm">

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Witness Full Name</mat-label>
      <input
        matInput
        placeholder="Witness Full Name"
        [(ngModel)]="witness.full_name"
        required
        name="full_name"
        type="text"
        #fullName
        matTooltip="The full name of the witness" />
      <mat-error *ngIf="!fullName.valid">Please enter the witnesses full name.
      </mat-error>
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Company Name</mat-label>
      <input
        matInput
        placeholder="Company Name"
        [(ngModel)]="witness.company_name"
        name="company_name"
        type="text"
        matTooltip="The name of the company the witness works for" />
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Email</mat-label>
      <input
        matInput
        placeholder="Email"
        [(ngModel)]="witness.email"
        name="email"
        type="email"
        matTooltip="The email address of the witness" />
    </mat-form-field>

    <app-phone-input
      [idInput]="phone_input_id"
      [numberInput]="witness.phone"
      [countryCodeInput]="witness.phone_country_code"
      [dialCodeInput]="witness.phone_dial_code"
      [e164NumberInput]="witness.phone_e164"
      (phoneDetailsOutput)="getOutputPhoneDetails($event)"
      [labelInput]="utils.getLangTerm('users.form.mobile', 'Mobile Number')"
      [required]="false">
    </app-phone-input>

    <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Statement</mat-label>
      <textarea
        matInput
        placeholder="Statement"
        [(ngModel)]="witness.statement"
        name="statement"
        rows="10">
      </textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="p-3">
  <button
    mat-raised-button
    [disabled]="!form.valid || inProgress || phone_error_state"
    color="primary"
    id="save"
    class="my-2 ml-1 mr-2"
    (click)="onSubmit()">
    <mat-icon>save</mat-icon>
    Save
  </button>

  <app-file-browse-button
    (selectedFiles)="onSelectFiles($event)"
    (afterDialogClosedEvent)="onSubmit()"
    parentObjectType="incident-witness"
    [parentObjectId]="witness?.id"
    [filesCount]="witness?.files?.length">
  </app-file-browse-button>

  <button
    mat-raised-button
    color="secondary"
    class="my-2 ml-1 mr-2"
    (click)="onSelectWitness()"
    matTooltip="If the user exists in our system, this can fill in the details for you."
    [matBadge]="witness.user_id ? 1 : 0">
    <mat-icon>person</mat-icon>
    Select Witness
  </button>

  <button
    type="button"
    mat-icon-button
    color="warn"
    [disabled]="!witness.user_id"
    class="dialog-remove-button my-2 ml-auto mr-1"
    (click)="onDelete()"
    matTooltip="Delete this Witness">
    <mat-icon>delete</mat-icon>
  </button>
</mat-dialog-actions>
